<div class="d-flex gap-4">
  <div class="d-flex align-items-center" [style.gap.rem]="0.75">
    <app-radio-button-input
      controlId="assetSelectionType-specify"
      [formControl]="control"
      name="assetSelectionType"
      [value]="AccountAssetSelectionTypeEnum.SpecifyAmount" />
    <app-form-option-label [labelFor]="'assetSelectionType-specify'" i18n>Specify Amount</app-form-option-label>
  </div>
  <div class="d-flex align-items-center" [style.gap.rem]="0.75">
    <app-radio-button-input
      controlId="assetSelectionType-allLocked"
      [formControl]="control"
      name="assetSelectionType"
      [value]="AccountAssetSelectionTypeEnum.AllLockedIn"
      [disabled]="!hasAnyLocked" />
    <app-form-option-label [labelFor]="'assetSelectionType-allLocked'" i18n>All Locked-In</app-form-option-label>
  </div>
  <div class="d-flex align-items-center" [style.gap.rem]="0.75">
    <app-radio-button-input
      controlId="assetSelectionType-allUnlocked"
      [formControl]="control"
      name="assetSelectionType"
      [value]="AccountAssetSelectionTypeEnum.AllNonLockedIn"
      [disabled]="!hasAnyUnlocked" />
    <app-form-option-label [labelFor]="'assetSelectionType-allUnlocked'" i18n>All Non-Locked-In</app-form-option-label>
  </div>
</div>
